import { CREATE_NOTICE, NOTICE, NOTICES, NOTICES_DISABLE,
  NOTICES_PAGINATE, NOTIFICATIONS_INCLUDE } from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'
import { toDeepFormData } from '@helpers/cast'
import formatedFilters from '@helpers/formatAxiosGetFilters'

const state = {
  notice: {},
  notices: [],
  paginate: {}
}

const getters = {
  [NOTICE]: 'notice',
  [NOTICES]: 'notices',
  [NOTICES_PAGINATE]: 'paginate'
}

const mutations = {
  [NOTICE]: 'notice',
  [NOTICES]: 'notices',
  [NOTICES_PAGINATE]: 'paginate'
}

const actions = {
  [NOTICE]: async ({ commit }, noticeId) => {
    const response = await axios.get(`/notification/${noticeId}`)
    const notice = response.data?.data || {}

    commit(NOTICE, notice || {})
  },

  [NOTICES]: async ({ commit }, params = '') => {
    const filters = formatedFilters(params)

    const response = await axios.get(`/notification?${filters}`)
    const { results: notices, pagination } = response.data?.data || {}

    commit(NOTICES, notices || [])
    commit(NOTICES_PAGINATE, pagination || {})
  },

  [CREATE_NOTICE]: async ({ commit, dispatch }, payload) => {
    const { id } = payload
    const method = id ? 'patch' : 'post'

    const data = toDeepFormData(payload)
    const response = await axios[method](`/notification${id ? '/' + id : ''}`, data)
      .then((res) => {
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'success',
          message: `Notificação ${method === 'patch' ? 'alterada' : 'criada'} com sucesso!`
        })

        return res
      }, () => {
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'error',
          message: 'Ocorreu um erro!'
        })
        return false
      })
    return response
  },

  [NOTICES_DISABLE]: async ({ dispatch }, payload) => {
    const notices = payload.map(notice => notice.id)
    await axios.post('/notification/group/patch', {
      ids: notices
    }).then((res) => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Notificações desativadas com sucesso!'
      })

      return res
    }, () => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro!'
      })
      return false
    })
    await dispatch(NOTICES)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/notices.js